import React, { useContext } from "react";
import { AddOn } from "../../../../data/entities";
import FormType, { FieldConfigs } from "../../../../shared/components/FormType";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";

interface FormContainerProps {
    validated: boolean;
    addOn: AddOn;
    mergeAddOn: Function;
}

const FormContainer = ({
                           validated,
                           addOn,
                           mergeAddOn,
                       }: FormContainerProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const fields: FieldConfigs[] = [
        { label: "Tên dịch vụ", type: "text", key: "name", required: true },
        {
            label: "Giá",
            type: "text",
            key: "price",
            required: true,
            numeric: true,
        },
        {
            label: "Danh mục",
            type: "dropdown",
            key: "category",
            options: [
                { text: "Phuy", value: "Phuy" },
                { text: "Thùng", value: "Thùng" },
                { text: "Cơ Khí Ô Tô", value: "Cơ Khí Ô Tô" },
            ],
            required: true,
        },
        {
            label: "Số lượng",
            type: "text",
            key: "quantity",
        },
    ];

    const getFields = () => {
        switch (role) {
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
            case ROLE.DELIVERER:
                return fields.map((item) => ({ ...item, disabled: true }));
            case ROLE.LOGISTIC_STAFF:
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return fields;
            default:
                return fields;
        }
    };

    return (
        <FormType
            title={"Thông tin dịch vụ"}
            fields={getFields()}
            validated={validated}
            requireData={{
                ...addOn,
                name: addOn.name,
                price: addOn.price,
                category: addOn.category,
                quantity: addOn.quantity,
            }}
            mergeFormData={mergeAddOn}
        />
    );
};

export default FormContainer;
